// viewport.js

export const setViewportMeta = (content) => {
  const viewportMeta = document.createElement("meta");
  viewportMeta.name = "viewport";
  viewportMeta.content = content;
  document.head.appendChild(viewportMeta);
};
